import { BsCheck } from "react-icons/bs";

export const Checkbox = ({ checked, ...props }) => (
  <div className="flex items-center">
    <input
      id="checkbox-all-search"
      type="checkbox"
      checked={checked}
      className="opacity-0 absolute peer"
      {...props}
    />
    <label
      htmlFor="checkbox-all-search"
      className="w-4 h-4 flex justify-center items-center border border-[#d8c9ae] rounded-full cursor-pointer
                                peer-checked:bg-[#d8c9ae] peer-checked:border-[#d8c9ae] peer-focus:ring-1 peer-focus:ring-[#d8c9ae]"
    >
      {checked && <BsCheck
        htmlFor="checkbox-all-search"
        className="  text-[#575757]" />}
    </label>
  </div>
)